var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "top", size: "small" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("template", { slot: "label" }, [
                            _c(
                              "div",
                              { staticClass: "selectLabel" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    model: {
                                      value: _vm.queryForm.params.timeType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "timeType",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.params.timeType",
                                    },
                                  },
                                  _vm._l(
                                    _vm.timeTypeList,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: false,
                              "default-time": ["00:00:00", "23:59:59"],
                              format:
                                _vm.$i18n.locale === "zh"
                                  ? _vm.zhDate
                                  : _vm.ptDate,
                              placeholder: _vm.$t("newOrder.SelectDatetime"),
                              "range-separator": "~",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.timeValue,
                              callback: function ($$v) {
                                _vm.timeValue = $$v
                              },
                              expression: "timeValue",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("template", { slot: "label" }, [
                            _c(
                              "div",
                              { staticClass: "selectLabel" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    model: {
                                      value: _vm.queryForm.params.numberType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "numberType",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.params.numberType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      key: "1",
                                      attrs: {
                                        label: _vm.$t(
                                          "GlobalSetObj.waybillNumber"
                                        ),
                                        value: 0,
                                      },
                                    }),
                                    _c("el-option", {
                                      key: "2",
                                      attrs: {
                                        label: _vm.$t(
                                          "GlobalSetObj.ScanNumber"
                                        ),
                                        value: 1,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "GlobalSetObj.CanBeEnteredMultiple2000"
                              ),
                              rows: 1,
                              type: "textarea",
                            },
                            model: {
                              value: _vm.returnWaybillNumber,
                              callback: function ($$v) {
                                _vm.returnWaybillNumber = $$v
                              },
                              expression: "returnWaybillNumber",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticStyle: { width: "auto" }, attrs: { span: 8 } },
                    [
                      _c(
                        "div",
                        { staticStyle: { "margin-top": "27px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.enterSearch },
                            },
                            [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "info" },
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                          ),
                          _c(
                            "el-radio-group",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { size: "small" },
                              on: { change: _vm.enterSearch },
                              model: {
                                value: _vm.queryForm.params.testData,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "testData",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.testData",
                              },
                            },
                            [
                              _c("el-radio-button", { attrs: { label: 1 } }, [
                                _vm._v(_vm._s(_vm.$t("newOrder.Formal"))),
                              ]),
                              _c("el-radio-button", { attrs: { label: 2 } }, [
                                _vm._v(_vm._s(_vm.$t("newOrder.test1"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.advancedSearch },
                },
                [_vm._v(_vm._s(_vm.$t("home.advancedSearch")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:complaintWorkOrder:bulkImport",
                      expression: "'btn:complaintWorkOrder:bulkImport'",
                      arg: "remove",
                    },
                  ],
                  attrs: { icon: "el-icon-upload2", size: "small" },
                  on: { click: _vm.allImportOrder },
                },
                [_vm._v(_vm._s(_vm.$t("newOrder.bulkImport")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:complaintWorkOrder:fixTime",
                      expression: "'btn:complaintWorkOrder:fixTime'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small" },
                  on: { click: _vm.clickDeadline },
                },
                [_vm._v(" " + _vm._s(_vm.$t("home.fixTime")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:complaintWorkOrder:fixResult",
                      expression: "'btn:complaintWorkOrder:fixResult'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small" },
                  on: { click: _vm.clickFixResult },
                },
                [_vm._v(" " + _vm._s(_vm.$t("home.fixResult")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:complaintWorkOrder:close",
                      expression: "'btn:complaintWorkOrder:close'",
                      arg: "remove",
                    },
                  ],
                  attrs: { icon: "el-icon-circle-close", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.closeOrder()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.Close")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:complaintWorkOrder:export",
                      expression: "'btn:complaintWorkOrder:export'",
                      arg: "remove",
                    },
                  ],
                  attrs: { icon: "el-icon-upload2", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.exportOrder()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("navbar.export")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:complaintWorkOrder:exportImage",
                      expression: "'btn:complaintWorkOrder:exportImage'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small" },
                  on: { click: _vm.exportOrderImage },
                },
                [_vm._v(" " + _vm._s(_vm.$t("home.exportPicture")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.orderNumberExport },
                },
                [_vm._v(_vm._s(_vm.$t("placeOrder.BatchExport")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:complaintWorkOrder:cancel",
                      expression: "'btn:complaintWorkOrder:cancel'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small" },
                  on: { click: _vm.cancelOrder },
                },
                [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.cancel")) + " ")]
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { staticStyle: { "margin-top": "10px" }, attrs: { span: 24 } },
                [
                  _vm.tipSearch.status
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: {
                            "disable-transitions": false,
                            closable: "",
                            effect: "dark",
                            size: "small",
                            type: "info",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleClose(1)
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("GlobalSetObj.ProcessingStatus")) +
                                ": "
                            ),
                          ]),
                          _c("span", [_vm._v(_vm._s(_vm.tipSearch.status))]),
                        ]
                      )
                    : _vm._e(),
                  _vm.tipSearch.result
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: {
                            "disable-transitions": false,
                            closable: "",
                            effect: "dark",
                            size: "small",
                            type: "info",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleClose(2)
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("collectionCenter.processingResult")
                              ) + ": "
                            ),
                          ]),
                          _c("span", [_vm._v(_vm._s(_vm.tipSearch.result))]),
                        ]
                      )
                    : _vm._e(),
                  _vm.tipSearch.istimeOut
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: {
                            "disable-transitions": false,
                            closable: "",
                            effect: "dark",
                            size: "small",
                            type: "info",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleClose(3)
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("orderCenterCont.TimeoutOrNot")) +
                                ": "
                            ),
                          ]),
                          _c("span", [_vm._v(_vm._s(_vm.tipSearch.istimeOut))]),
                        ]
                      )
                    : _vm._e(),
                  _vm.tipSearch.customerName
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: {
                            "disable-transitions": false,
                            closable: "",
                            effect: "dark",
                            size: "small",
                            type: "info",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleClose(4)
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("GlobalSetObj.client")) + ": "
                            ),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.tipSearch.customerName)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.tipSearch.merchantName
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: {
                            "disable-transitions": false,
                            closable: "",
                            effect: "dark",
                            size: "small",
                            type: "info",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleClose(5)
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("placeOrder.CommercialOwner")) +
                                ": "
                            ),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.tipSearch.merchantName)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.tipSearch.stateName
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: {
                            "disable-transitions": false,
                            closable: "",
                            effect: "dark",
                            size: "small",
                            type: "info",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleClose(6)
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("collectionCenter.stateSite1")) +
                                ": "
                            ),
                          ]),
                          _c("span", [_vm._v(_vm._s(_vm.tipSearch.stateName))]),
                        ]
                      )
                    : _vm._e(),
                  _vm.tipSearch.siteName
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: {
                            "disable-transitions": false,
                            closable: "",
                            effect: "dark",
                            size: "small",
                            type: "info",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleClose(7)
                            },
                          },
                        },
                        [
                          _c("span", [_vm._v(_vm._s("网点") + ": ")]),
                          _c("span", [_vm._v(_vm._s(_vm.tipSearch.siteName))]),
                        ]
                      )
                    : _vm._e(),
                  _vm.tipSearch.registerUserName
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: {
                            "disable-transitions": false,
                            closable: "",
                            effect: "dark",
                            size: "small",
                            type: "info",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleClose(8)
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("collectionCenter.registrar")) +
                                ": "
                            ),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.tipSearch.registerUserName)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.tipSearch.complaintTypeName
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: {
                            "disable-transitions": false,
                            closable: "",
                            effect: "dark",
                            size: "small",
                            type: "info",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleClose(9)
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("tablePrice.complaintType")) + ": "
                            ),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.tipSearch.complaintTypeName)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.tipSearch.workOrderTypeName
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: {
                            "disable-transitions": false,
                            closable: "",
                            effect: "dark",
                            size: "small",
                            type: "info",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleClose(10)
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("tablePrice.workOrderType")) + ": "
                            ),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.tipSearch.workOrderTypeName)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card", staticStyle: { "margin-top": "10px" } },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { "margin-top": "-10px" },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", { attrs: { name: "-1" } }, [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("GlobalSetObj.all")) +
                      " " +
                      _vm._s(_vm.getOrderTypeTotalDataRes.total) +
                      " "
                  ),
                ]),
              ]),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    disabled: _vm.getOrderTypeTotalDataRes.falseSignTotal === 0,
                    name: "1",
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "compensationManagement.FalseSigningForDelivery"
                          )
                        ) +
                        " " +
                        _vm._s(_vm.getOrderTypeTotalDataRes.falseSignTotal)
                    ),
                  ]),
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    disabled:
                      _vm.getOrderTypeTotalDataRes.suspectedLossTotal === 0,
                    name: "0",
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("operationTips.yisiLost")) +
                        " " +
                        _vm._s(
                          _vm.getOrderTypeTotalDataRes.suspectedLossTotal
                        ) +
                        " "
                    ),
                  ]),
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    disabled: _vm.getOrderTypeTotalDataRes.missingTotal === 0,
                    name: "2",
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("compensationManagement.wrongOrMissingItems")
                        ) +
                        " " +
                        _vm._s(_vm.getOrderTypeTotalDataRes.missingTotal) +
                        " "
                    ),
                  ]),
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    disabled: _vm.getOrderTypeTotalDataRes.damagedTotal === 0,
                    name: "3",
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("compensationManagement.damagedItems")) +
                        " " +
                        _vm._s(_vm.getOrderTypeTotalDataRes.damagedTotal) +
                        " "
                    ),
                  ]),
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    disabled:
                      _vm.getOrderTypeTotalDataRes.businessComplainTotal === 0,
                    name: "4",
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("compensationManagement.CommercialComplaint")
                        ) +
                        " " +
                        _vm._s(
                          _vm.getOrderTypeTotalDataRes.businessComplainTotal
                        ) +
                        " "
                    ),
                  ]),
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    disabled:
                      _vm.getOrderTypeTotalDataRes.reclameAquiTotal === 0,
                    name: "5",
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      " " +
                        _vm._s("Reclame Aqui") +
                        " " +
                        _vm._s(_vm.getOrderTypeTotalDataRes.reclameAquiTotal) +
                        " "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "tableRef",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                height: "520",
                "row-key": "id",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  fixed: "left",
                  type: "selection",
                  width: "50",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "70",
                },
              }),
              _vm._l(_vm.tableHeaderList, function (item) {
                return _c("el-table-column", {
                  key: item.id,
                  attrs: {
                    align: item.align,
                    label: item.label,
                    "min-width": item.cloWidth,
                    prop: item.prop,
                    "show-overflow-tooltip": true,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "processingState"
                              ? _c(
                                  "div",
                                  [
                                    scope.row[item.prop] === 0
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "success",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("GlobalSetObj.Pending")
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : scope.row[item.prop] === 1
                                      ? _c(
                                          "el-tag",
                                          { attrs: { size: "small" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("newOrder.processing")
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : scope.row[item.prop] === 2
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "warning",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "collectionCenter.closedLoop"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : scope.row[item.prop] === 3
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "danger",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "collectionCenter.cancelled"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : item.prop === "isLastReply"
                              ? _c("div", [
                                  scope.row.processingState === 2
                                    ? _c("div", [_vm._v("-")])
                                    : _c(
                                        "div",
                                        [
                                          scope.row[item.prop] === 0
                                            ? _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    type: "info",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("GlobalSetObj.No")
                                                    ) + " "
                                                  ),
                                                ]
                                              )
                                            : scope.row[item.prop] === 1
                                            ? _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    type: "success",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("GlobalSetObj.yes")
                                                    ) + " "
                                                  ),
                                                ]
                                              )
                                            : !scope.row[item.prop]
                                            ? _c("div", [_vm._v("-")])
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                ])
                              : item.prop === "isTimeOut"
                              ? _c(
                                  "div",
                                  [
                                    scope.row[item.prop] === 0
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("GlobalSetObj.No")
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : scope.row[item.prop] === 1
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "success",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("GlobalSetObj.yes")
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : item.prop === "lastReplyContent"
                              ? _c("div", [
                                  scope.row[item.prop] !== null &&
                                  scope.row[item.prop] !== "" &&
                                  scope.row[item.prop] !== undefined
                                    ? _c("div", [
                                        _c("div", {
                                          staticClass: "tableImg",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              scope.row[item.prop]
                                            ),
                                          },
                                        }),
                                      ])
                                    : _c("div", [_vm._v("-")]),
                                ])
                              : _c("div", [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(scope.row[item.prop] || "--")
                                    ),
                                  ]),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("newOrder.operation"),
                  align: "center",
                  fixed: "right",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.processingState !== 3
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-around",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    directives: [
                                      {
                                        name: "permit",
                                        rawName: "v-permit:remove",
                                        value: "btn:complaintWorkOrder:Reply",
                                        expression:
                                          "'btn:complaintWorkOrder:Reply'",
                                        arg: "remove",
                                      },
                                    ],
                                    staticClass: "item",
                                    attrs: {
                                      content: _vm.$t("GlobalSetObj.Reply"),
                                      effect: "dark",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-chakantiezihuifu textOperator2",
                                      on: {
                                        click: function ($event) {
                                          return _vm.replyMessage(scope.row)
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                scope.row.processingState !== 2
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        directives: [
                                          {
                                            name: "permit",
                                            rawName: "v-permit:remove",
                                            value:
                                              "btn:complaintWorkOrder:close",
                                            expression:
                                              "'btn:complaintWorkOrder:close'",
                                            arg: "remove",
                                          },
                                        ],
                                        staticClass: "item",
                                        attrs: {
                                          content: _vm.$t("GlobalSetObj.Close"),
                                          effect: "dark",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-circle-close textOperator",
                                          on: {
                                            click: function ($event) {
                                              return _vm.closeOrder(scope.row)
                                            },
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c("el-pagination", {
            staticStyle: { margin: "10px 0", float: "right" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 50, 100, 500, 1000],
              total: _vm.queryForm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          staticClass: "drawerClass",
          attrs: {
            "close-on-click-modal": true,
            "destroy-on-close": true,
            title: _vm.$t("GlobalSetObj.CommunicationContent"),
            visible: _vm.seeDialogVisible,
            direction: "ltr",
            size: "1000px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.seeDialogVisible = $event
            },
            close: _vm.closeDrawer,
          },
        },
        [
          _c("messageDetail", {
            ref: "messageDetail",
            attrs: { "reply-message-data": _vm.replyMessageData },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("basicData.BulkImport"),
            visible: _vm.importForm.messageRemrkDialog,
            top: "5vh",
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.importForm, "messageRemrkDialog", $event)
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "div",
            { staticClass: "remarkBox" },
            [
              _c(
                "el-form",
                {
                  key: _vm.importForm.messageRemrkDialog,
                  ref: "importForm",
                  attrs: { model: _vm.importForm, "label-position": "top" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "importNumberType" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: _vm.importForm.importNumberType,
                            callback: function ($$v) {
                              _vm.$set(_vm.importForm, "importNumberType", $$v)
                            },
                            expression: "importForm.importNumberType",
                          },
                        },
                        [
                          _c("el-option", {
                            key: "1",
                            attrs: {
                              label: _vm.$t("GlobalSetObj.waybillNumber"),
                              value: 0,
                            },
                          }),
                          _c("el-option", {
                            key: "2",
                            attrs: {
                              label: _vm.$t("GlobalSetObj.ScanNumber"),
                              value: 1,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        rules: {
                          required: true,
                          message: _vm.$t("GlobalSetObj.pleaseInput"),
                          trigger: ["blur", "change"],
                        },
                        prop: "importNumber",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            "receivablePayable.MultipleNumberWrapEntry"
                          ),
                          rows: 6,
                          type: "textarea",
                        },
                        model: {
                          value: _vm.importForm.importNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.importForm, "importNumber", $$v)
                          },
                          expression: "importForm.importNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("tablePrice.workOrderType"),
                        rules: {
                          required: true,
                          message: _vm.$t("GlobalSetObj.pleaseInput"),
                          trigger: ["blur", "change"],
                        },
                        prop: "workOrderType",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          on: { change: _vm.changeWorkOrderType },
                          model: {
                            value: _vm.importForm.workOrderType,
                            callback: function ($$v) {
                              _vm.$set(_vm.importForm, "workOrderType", $$v)
                            },
                            expression: "importForm.workOrderType",
                          },
                        },
                        [
                          _c("el-option", {
                            key: "0",
                            attrs: {
                              label: _vm.$t(
                                "compensationManagement.FalseSigningForDelivery"
                              ),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value: "btn:complaintWorkOrder:orSign",
                                expression: "'btn:complaintWorkOrder:orSign'",
                                arg: "remove",
                              },
                            ],
                            key: "1",
                            attrs: {
                              label: _vm.$t("operationTips.yisiLost"),
                              value: 0,
                            },
                          }),
                          _c("el-option", {
                            key: "2",
                            attrs: {
                              label: _vm.$t(
                                "compensationManagement.wrongOrMissingItems"
                              ),
                              value: 2,
                            },
                          }),
                          _c("el-option", {
                            key: "3",
                            attrs: {
                              label: _vm.$t(
                                "compensationManagement.damagedItems"
                              ),
                              value: 3,
                            },
                          }),
                          _c("el-option", {
                            key: "4",
                            attrs: {
                              label: _vm.$t(
                                "compensationManagement.CommercialComplaint"
                              ),
                              value: 4,
                            },
                          }),
                          _c("el-option", {
                            key: "5",
                            attrs: { value: 5, label: "Reclame Aqui" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.importForm.workOrderType === 5
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("tablePrice.complaintReason"),
                            rules: {
                              required: true,
                              message: _vm.$t("GlobalSetObj.pleaseInput"),
                              trigger: ["blur", "change"],
                            },
                            prop: "complaintReason",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.importForm.complaintReason,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.importForm,
                                    "complaintReason",
                                    $$v
                                  )
                                },
                                expression: "importForm.complaintReason",
                              },
                            },
                            _vm._l(_vm.complaintReasonList, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.importForm.workOrderType === 5
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            rules: {
                              required: true,
                              message: _vm.$t("GlobalSetObj.pleaseInput"),
                              trigger: ["blur", "change"],
                            },
                            label: "Hugme ID",
                            prop: "hugmeId",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                              clearable: "",
                              maxlength: "50",
                              "show-word-limit": "",
                            },
                            on: { input: _vm.numberInput },
                            model: {
                              value: _vm.importForm.hugmeId,
                              callback: function ($$v) {
                                _vm.$set(_vm.importForm, "hugmeId", $$v)
                              },
                              expression: "importForm.hugmeId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.importForm.workOrderType === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("tablePrice.complaintType"),
                            rules: {
                              required: true,
                              message: _vm.$t("GlobalSetObj.pleaseChoose"),
                              trigger: ["blur", "change"],
                            },
                            prop: "complaintType",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.importForm.complaintType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.importForm, "complaintType", $$v)
                                },
                                expression: "importForm.complaintType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("tablePrice.consumerComplaint"))
                                ),
                              ]),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("tablePrice.platformComplaint"))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("tablePrice.SelectProcessingHub"),
                        rules: {
                          required: true,
                          message: _vm.$t("GlobalSetObj.pleaseChoose"),
                          trigger: ["blur", "change"],
                        },
                        prop: "siteType",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticStyle: { "line-height": "30px" },
                          model: {
                            value: _vm.importForm.siteType,
                            callback: function ($$v) {
                              _vm.$set(_vm.importForm, "siteType", $$v)
                            },
                            expression: "importForm.siteType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(
                              _vm._s(_vm.$t("tablePrice.ActualDeliveryHub"))
                            ),
                          ]),
                          _vm.importForm.workOrderType === 5
                            ? _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("GlobalSetObj.preEntrega")) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          _c(
                            "el-radio",
                            {
                              directives: [
                                {
                                  name: "permitBtn",
                                  rawName: "v-permitBtn:remove",
                                  value: "btn:complaintWorkOrder:headOffice",
                                  expression:
                                    "'btn:complaintWorkOrder:headOffice'",
                                  arg: "remove",
                                },
                              ],
                              attrs: { label: 2 },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("collectionCenter.headOffice")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm.importForm.workOrderType === 5
                            ? _c("el-radio", { attrs: { label: 4 } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("fixDutyFine.LatestTrackingBranch")
                                    )
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.importForm.workOrderType === 5
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("receivablePayable.complaintLink"),
                            rules: {
                              required: true,
                              message: _vm.$t("GlobalSetObj.pleaseInput"),
                              trigger: ["blur", "change"],
                            },
                            prop: "complaintLink",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: 300,
                              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                              rows: 3,
                              "show-word-limit": "",
                              type: "textarea",
                            },
                            model: {
                              value: _vm.importForm.complaintLink,
                              callback: function ($$v) {
                                _vm.$set(_vm.importForm, "complaintLink", $$v)
                              },
                              expression: "importForm.complaintLink",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.messageRemarkSubmit(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.messageRemarkSubmit(2)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("GlobalSetObj.ImportResults"),
            visible: _vm.resultData.showImportResults,
            width: "710px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.resultData, "showImportResults", $event)
            },
          },
        },
        [
          _c("div", { staticClass: "remarkBox" }, [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c("div", { staticStyle: { width: "220px" } }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("receivablePayable.TotalImport")) + "："
                ),
                _c("span", { staticStyle: { color: "#00A551" } }, [
                  _vm._v(_vm._s(_vm.resultData.all)),
                ]),
              ]),
              _c("div", { staticStyle: { flex: "1" } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("orderCenterCont.ImportWasSuccessful")) +
                    "：" +
                    _vm._s(_vm.resultData.success) +
                    " "
                ),
              ]),
              _c("div", { staticStyle: { width: "220px" } }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("orderCenterCont.ImportFailed")) + "："
                ),
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(_vm.resultData.err)),
                ]),
              ]),
            ]),
            _vm.resultData.err > 0
              ? _c("div", [
                  _c("div", { staticStyle: { margin: "20px 0 0 0" } }, [
                    _vm._v(_vm._s(_vm.$t("GlobalSetObj.ReasonForFailure"))),
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "max-height": "310px",
                        "overflow-y": "auto",
                      },
                    },
                    _vm._l(_vm.resultData.errData, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticStyle: { "margin-top": "10px" } },
                        [
                          _c("span", [
                            _vm._v(_vm._s(index) + "：" + _vm._s(item)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.resultData.showImportResults = false
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("collectionCenter.processingResult"),
            visible: _vm.closeReturn.showCloseComplaints,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.closeReturn, "showCloseComplaints", $event)
            },
            close: function ($event) {
              return _vm.closeReturnSubmit(1)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "remarkBox" },
            [
              _c("div", { staticStyle: { margin: "10px 0" } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("GlobalSetObj.totalOptions")) +
                    "：" +
                    _vm._s(_vm.closeReturn.selectedNum) +
                    " "
                ),
              ]),
              _c(
                "el-form",
                {
                  key: _vm.closeReturn.showCloseComplaints,
                  ref: "closeReturn",
                  attrs: { model: _vm.closeReturn },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: {
                        label: _vm.$t("collectionCenter.processingResult"),
                        rules: {
                          required: true,
                          message: _vm.$t("GlobalSetObj.pleaseChoose"),
                          trigger: ["change", "blur"],
                        },
                        prop: "processingResult",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                          },
                          model: {
                            value: _vm.closeReturn.processingResult,
                            callback: function ($$v) {
                              _vm.$set(_vm.closeReturn, "processingResult", $$v)
                            },
                            expression: "closeReturn.processingResult",
                          },
                        },
                        _vm._l(
                          _vm.processingResultList01,
                          function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.label, value: item.value },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.isScore
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("receivablePayable.rating"),
                            rules: [
                              {
                                pattern:
                                  /^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?)$/,
                                message:
                                  "" +
                                  _vm.$t("receivablePayable.numberRangeLimit"),
                                trigger: ["blur", "change"],
                              },
                            ],
                            clearable: "",
                            prop: "score",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: 6,
                              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.closeReturn.score,
                              callback: function ($$v) {
                                _vm.$set(_vm.closeReturn, "score", $$v)
                              },
                              expression: "closeReturn.score",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.closeReturnSubmit(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.closeReturnSubmit(2)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("home.fixTime"),
            visible: _vm.changeDeadline,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.changeDeadline = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "40px" } },
            [
              _c("el-date-picker", {
                attrs: {
                  placeholder: _vm.$t("order.orderDatePlaceholder"),
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                },
                model: {
                  value: _vm.time01,
                  callback: function ($$v) {
                    _vm.time01 = $$v
                  },
                  expression: "time01",
                },
              }),
              _c("el-time-picker", {
                staticStyle: { "margin-left": "30px" },
                attrs: {
                  placeholder: _vm.$t("base.selectTime"),
                  "value-format": "HH:mm:ss",
                },
                model: {
                  value: _vm.time02,
                  callback: function ($$v) {
                    _vm.time02 = $$v
                  },
                  expression: "time02",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.changeDeadline = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.confirmUpdataDeadline },
                },
                [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("home.fixResult"),
            visible: _vm.modifyingResultDialog,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.modifyingResultDialog = $event
            },
            close: function ($event) {
              return _vm.submitModifyingResult(1)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "remarkBox" },
            [
              _c("div", { staticStyle: { margin: "10px 0", color: "black" } }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("GlobalSetObj.totalOptions")) + "："
                ),
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(_vm.modifyingResult.selectedNum)),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "selectLabel",
                  staticStyle: { "margin-bottom": "5px" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "170px" },
                      on: { change: _vm.changeResultType },
                      model: {
                        value: _vm.modifyingResult.updateType,
                        callback: function ($$v) {
                          _vm.$set(_vm.modifyingResult, "updateType", $$v)
                        },
                        expression: "modifyingResult.updateType",
                      },
                    },
                    [
                      _c("el-option", {
                        key: 1111,
                        attrs: { label: _vm.$t("home.modifyStatus"), value: 0 },
                      }),
                      _c("el-option", {
                        key: 2222,
                        attrs: { label: _vm.$t("home.modifyResult"), value: 1 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: _vm.$t("GlobalSetObj.pleaseChoose") },
                  model: {
                    value: _vm.modifyingResult.updateProcessingResult,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.modifyingResult,
                        "updateProcessingResult",
                        $$v
                      )
                    },
                    expression: "modifyingResult.updateProcessingResult",
                  },
                },
                _vm._l(_vm.fixList, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.submitModifyingResult(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitModifyingResult(2)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("GlobalSetObj.tips"),
            visible: _vm.tipDialog,
            width: "550px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.tipDialog = $event
            },
          },
        },
        [
          _c("div", [
            _c("div", { staticClass: "flx-between" }, [
              _c("div", [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("home.operationTotal")) + "："),
                ]),
                _c("span", [_vm._v(_vm._s(_vm.tipObj.totalNumber))]),
              ]),
              _c("div", [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("operationCenter.NumberOfSuccesses")) + "："
                  ),
                ]),
                _c("span", [_vm._v(_vm._s(_vm.tipObj.succeedNumber))]),
              ]),
              _c("div", [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("operationCenter.NumberOfFailures")) + "："
                  ),
                ]),
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(_vm.tipObj.failNumber)),
                ]),
              ]),
            ]),
            _vm.tipObj.failNumber
              ? _c(
                  "div",
                  { staticStyle: { height: "200px", "overflow-y": "auto" } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "20px",
                          "margin-bottom": "8px",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("GlobalSetObj.ReasonForFailure")) +
                            ": "
                        ),
                      ]
                    ),
                    _vm._l(_vm.tipObj.failMap, function (key, val, index) {
                      return _c("div", { key: key }, [
                        _c("span", [_vm._v(_vm._s(index + 1) + ". ")]),
                        _c("span", [_vm._v(_vm._s(key) + ": ")]),
                        _c("span", [_vm._v(_vm._s(val))]),
                      ])
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.tipDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Close")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("searchCom", {
        ref: "searchComRef",
        on: { "child-event01": _vm.parentMethod01 },
      }),
      _c("exportImage", { ref: "exportImageRef" }),
      _c("exportOrderNumber", { ref: "exportOrderNumberRef" }),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("collectionCenter.alert"),
            visible: _vm.closeCancelDialog,
            width: "350px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.closeCancelDialog = $event
            },
            close: _vm.cancelDialogClose,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "padding-left": "20px",
                "box-sizing": "border-box",
              },
            },
            [
              _c("p", { staticStyle: { "font-size": "16px" } }, [
                _vm._v(_vm._s(_vm.$t("collectionCenter.confirmCancelTickets"))),
              ]),
              _c("p", { staticStyle: { "font-size": "16px" } }, [
                _vm._v(_vm._s(_vm.$t("collectionCenter.cancelIrreversible"))),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.cancelDialogClose },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.cancelSubmit },
                },
                [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("operationCenter.TheResultOfTheOperation"),
            visible: _vm.closeOperationResultDialog,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.closeOperationResultDialog = $event
            },
            close: _vm.operationResultDialogClose,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "align-items": "center",
                    "flex-wrap": "wrap",
                  },
                },
                [
                  _c("el-col", { attrs: { span: 7 } }, [
                    _c("span", { staticStyle: { "text-align": "left" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("home.operationTotal")) +
                          "：" +
                          _vm._s(_vm.cancelResult.totalCount)
                      ),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 7 } }, [
                    _c("span", { staticStyle: { "text-align": "left" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("Resource.successCount")) +
                          "：" +
                          _vm._s(_vm.cancelResult.successCount)
                      ),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 7 } }, [
                    _c("span", { staticStyle: { "text-align": "left" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("GlobalSetObj.FailureCount")) + "："
                      ),
                      _c("span", { staticStyle: { color: "#e02f45" } }, [
                        _vm._v(_vm._s(_vm.cancelResult.failCount)),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._l(_vm.cancelResult.failReasonList, function (item, idx) {
                return _c("div", { key: idx }, [
                  _vm._v(
                    " " +
                      _vm._s(idx + 1) +
                      ". " +
                      _vm._s(item.waybillNumber) +
                      "，" +
                      _vm._s(item.reason) +
                      " "
                  ),
                ])
              }),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.cancelConfirm } },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }